import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { CardDescription } from '@/shared/ui/core';
import styles from './registration-card.module.scss';


export function RegistrationCardDescription ({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
    return (
        <CardDescription
            className={ cn(styles.description, className) }
            data-template="registration-card-description"
            { ...props }
        />
    );
}
